<template>
  <div class="powerText2">
    <section class="row m-0 lxing">
      <router-link to="/aidc" class="nav-link">
        <img class="banner-img" :src="$t('centerDataImg')" alt="数据中心配图" />
      </router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'powerText',
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="scss">
.lxing {
  overflow: hidden;

  img {
    border-radius: 10px;
  }
}
.lxing ::v-deep .banner-img {
  display: block;
  width: 100%;
}
</style>
